import { CardRoot } from '@chakra-ui/react';

export const MCard = CardRoot;
